'use strict';

exports.__esModule = true;
exports.Calls = undefined;

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

var _MainView = require('./MainView');

var _MainView2 = _interopRequireDefault(_MainView);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import Page from "../layout";

/**
 * Модуль звонков
 */


var styles = {
  root: {}
};
var Calls = exports.Calls = (_temp2 = _class = function (_Component) {
  _inherits(Calls, _Component);

  function Calls() {
    var _temp, _this, _ret;

    _classCallCheck(this, Calls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _this.callUser = function (userId, roomId) {
      var callUser = _this.context.callUser;
      return callUser(userId, {
        room: roomId
      });
    }, _this.closeCall = function () {
      var _this$context = _this.context,
          closeCall = _this$context.closeCall,
          connections = _this$context.connections;
      connections && connections[0] && connections[0].close();
      closeCall();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // callUser


  Calls.prototype.render = function render() {
    var _context = this.context,
        connections = _context.connections,
        streams = _context.streams,
        callRequests = _context.callRequests,
        acceptCall = _context.acceptCall,
        rejectCall = _context.rejectCall,
        router = _context.router;
    var currentUser = this.context.user;
    var _props = this.props,
        classes = _props.classes,
        ChatRoom = _props.ChatRoom;

    if (!currentUser) {
      return null;
    }

    var currentUserId = currentUser.id;
    var callsView = []; // Активная иконка должна быть только одна

    var actionButton = void 0;
    /**
     * Входящий запрос
     * ToDo Надо будет перевести на отображение множественных звонков
     */

    var currentCallRequest = void 0; // let activeCall;

    var activeCallRequest = callRequests && callRequests.find(function (n) {
      return ["Started"].indexOf(n.status) !== -1;
    });

    if (activeCallRequest) {
      currentCallRequest = activeCallRequest; // activeCall = activeCallRequest.Call.id;
    } else {
      currentCallRequest = callRequests && callRequests.find(function (n) {
        return ["Created", "Accepted", "Started"].indexOf(n.status) !== -1;
      });
    } // const requestedCalls = callRequests && callRequests.filter(n => ["Created"].indexOf(n.status) !== -1) || [];
    // return "sdfdsf";
    // requestedCalls.map(requestedCall => {
    //   const {
    //     id: callRequestId,
    //     // status,
    //     Called: {
    //       id: calledId,
    //     },
    //     // Call: {
    //     //   // id: callId,
    //     // },
    //     Room: {
    //       id: room,
    //     },
    //   } = requestedCall;
    //   /**
    //    * Если это новый звонок и адресован текущему пользователю, выводим запрос
    //    */
    //   if (calledId === currentUserId) {
    //     callsView.push(<CallRequestButton
    //       key={callRequestId}
    //       item={currentCallRequest}
    //       accept={event => {
    //         acceptCall(callRequestId);
    //         // setActiveCall(room);
    //         // setActiveCall(currentCallRequest);
    //       }}
    //       reject={event => {
    //         rejectCall(callRequestId);
    //       }}
    //     />)
    //   }
    // });
    // callsView.push(<CallRequestButtons
    //   // key={callRequestId}
    //   // item={currentCallRequest}
    //   // accept={event => {
    //   //   acceptCall(callRequestId);
    //   //   // setActiveCall(room);
    //   //   // setActiveCall(currentCallRequest);
    //   // }}
    //   // reject={event => {
    //   //   rejectCall(callRequestId);
    //   // }}
    // />)


    if (currentCallRequest) {
      var _currentCallRequest = currentCallRequest,
          callRequestId = _currentCallRequest.id,
          status = _currentCallRequest.status,
          calledId = _currentCallRequest.Called.id,
          room = _currentCallRequest.Room.id;
      /**
       * Если звонок активный, выводим иконку, чтобы всегда можно было перейти в него
       */
      // if (status === "Started" && room) {
      //   callsView.push(<IconButton
      //     key="activeCall"
      //     onClick={event => {
      //       router.history.push(`/inbox/${room}/`)
      //     }}
      //   >
      //     <TalkIcon
      //       style={{
      //         // color: activeCall ? undefined : "green",
      //         color: "green",
      //       }}
      //     />
      //   </IconButton>);
      // }
    } // activeCall && callsView.push(<MainView
    //   key={activeCall}
    //   user={currentUser}
    //   // where={{
    //   //   // id: activeCall,
    //   //   callId: activeCall,
    //   // }}
    //   callUser={this.callUser}
    //   streams={streams}
    //   connection={connections ? connections[0] : null}
    //   closeCall={this.closeCall}
    //   callRequests={callRequests}
    // />);


    callsView.push(_react2.default.createElement(_MainView2.default // key={`MainView_${activeCall}`}
    , {
      key: 'MainView',
      user: currentUser,
      ChatRoom: ChatRoom // where={{
      //   // id: activeCall,
      //   callId: activeCall,
      // }}
      ,
      callUser: this.callUser,
      streams: streams,
      connection: connections ? connections[0] : null,
      closeCall: this.closeCall,
      callRequests: callRequests
    })); // if (activeCallRequest) {
    //   actionButton = <IconButton
    //     key="close"
    //     onClick={event => this.closeCall()}
    //   >
    //     <CloseIcon />
    //   </IconButton>
    // }

    if (actionButton) {
      callsView.push(actionButton);
    }

    return callsView; // return callsView && callsView.length ? <div
    //   className={classes.root}
    // >
    //   {callsView}
    // </div>
    //   : null
  };

  return Calls;
}(_react.Component), _class.contextType = _context3.default, _class.contextTypes__ = {
  localStream: _propTypes2.default.object,
  peerConnections: _propTypes2.default.array.isRequired,
  callRequests: _propTypes2.default.array.isRequired,
  callUser: _propTypes2.default.func.isRequired,
  acceptCall: _propTypes2.default.func.isRequired,
  rejectCall: _propTypes2.default.func.isRequired,
  // setActiveCall: PropTypes.func.isRequired,
  closeCall: _propTypes2.default.func.isRequired,
  connections: _propTypes2.default.array.isRequired,
  streams: _propTypes2.default.array.isRequired
}, _temp2);
Calls.propTypes = process.env.NODE_ENV !== "production" ? {
  // ...Page.propTypes,
  // user: PropTypes.object.isRequired,
  classes: _propTypes2.default.object.isRequired
} : {};
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(Calls, props);
});